import _mixin from '../_mixin'

export default {
  name: 'SAppointmentActivity',
  cnName: '预约活动',
  type: 'activity_other',
  needLogin: true,
  preview: 'https://rescdn-crash.ssjj.cn/website/2025/10/31/e069740342c6c425c3603da0d4c75151.jpeg',
  props: {
    appointmentId: '6803c88926302816744e90f8',
    activityAId: '6803c88926302816744e90f8',
    activityGId: '1234',
    newId: '6803c88926302816744e90f8',
    bg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/27/02f5687ad4aa1d40754a40562f39cee5.png',
      style: {
        width: '100%',
        height: '993px'
      }
    },
    btnRule: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/28/cc9ca93c71695b13b3d815ae4ec0220b.png',
      style: {
        width: '87px',
        height: '16px',
        position: 'absolute',
        top: '440px',
        right: '',
        bottom: '',
        left: '300px'
      }
    },
    btnStatusSize: '306px 73px',
    btnStatusPosition: '500px 0 0 200px',
    btnNoAppointment: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/28/955436a20d941d0c553bcb849809cd75.png'
    },
    btnAppointment: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/28/4eaa33fdd12b0c74c2b48464308baeb9.png'
    },
    btnNoReceive: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/28/f2bc978ad44ae8eb1940e70e17056d1e.png'
    },
    btnReceived: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/28/d49b46e3fc6300c31e7ebf02ee035916.png'
    },
    btnExpire: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/28/799bc1238c39ac02df83ec370b8b1e8e.png'
    },
    progressSize: '717px 25px',
    progressPosition: '_ _ 150px 100px',
    progressCoin: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/28/3a89688c52742a2001d2ed1c53297125.png',
      style: {
        width: '16px',
        height: '28px'
      }
    },
    progressCoinActive: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/28/26848eb593afba1634123fa194db14bb.png',
      style: {
        width: '16px',
        height: '28px'
      }
    },
    numList: [
      {
        num: '200000'
      },
      {
        num: '400000'
      },
      {
        num: '600000'
      },
      {
        num: '800000'
      },
      {
        num: '1000000'
      }
    ],
    progressColor: 'red',
    numColor: '#333333',
    modalBg: {
      src: 'https://rescdn.ssjj.cn/website/2024/01/30/86c1aac7bc41c347173a1f7df26a39da.png',
      style: {
        width: '750px',
        height: '500px'
      }
    },
    modalCloseIcon: {
      src: 'https://rescdn.ssjj.cn/website/2024/01/30/8a1698878335f98187a3b9fb1e60f6a8.png',
      style: {
        width: '40px',
        height: '40px',
        right: '10px',
        top: '10px'
      }
    },
    modalTitleStyle: '{}',
    modalTextStyle: '{"padding": "20px"}'
  },
  propsDesc: [
    {
      target: 'appointmentId',
      label: '预约id'
    },
    {
      target: 'activityGId',
      label: '活动Gid'
    },
    {
      target: 'activityAId',
      label: '活动Aid'
    },
    {
      target: 'newId',
      label: '新闻id'
    },
    {
      target: 'bg',
      label: '背景',
      formType: 'image'
    },
    {
      target: 'btnRule',
      label: '活动规则',
      formType: 'image'
    },
    {
      target: 'btnStatusSize',
      label: '状态按钮大小'
    },
    {
      target: 'btnStatusPosition',
      label: '状态按钮位置',
      formType: 'position'
    },
    {
      target: 'btnNoAppointment',
      label: '未预约',
      formType: 'image'
    },
    {
      target: 'btnAppointment',
      label: '已预约',
      formType: 'image'
    },
    {
      target: 'btnNoReceive',
      label: '未领取',
      formType: 'image'
    },
    {
      target: 'btnReceived',
      label: '已领取',
      formType: 'image'
    },
    {
      target: 'btnExpire',
      label: '已过期',
      formType: 'image'
    },
    {
      target: '进度条',
      formType: 'divider'
    },
    {
      target: 'progressSize',
      label: '进度条大小'
    },
    {
      target: 'progressPosition',
      label: '进度条位置',
      formType: 'position'
    },
    {
      target: 'progressCoin',
      label: '进度刻度',
      formType: 'image'
    },
    {
      target: 'progressCoinActive',
      label: '当前进度刻度',
      formType: 'image'
    },
    {
      target: 'numList',
      label: '数值列表',
      formType: 'list',
      listConfig: [
        {
          title: '数值',
          target: 'num'
        }
      ]
    },
    {
      target: 'progressColor',
      label: '进度条颜色',
      formType: 'color'
    },
    {
      target: 'numColor',
      label: '数值颜色',
      formType: 'color'
    },
    {
      target: '公共弹窗',
      formType: 'divider'
    },
    {
      target: 'modalBg',
      label: '弹窗背景图',
      formType: 'image'
    },
    {
      target: 'modalCloseIcon',
      label: '关闭按钮',
      formType: 'image'
    },
    {
      target: 'modalTitleStyle',
      label: '标题样式',
      formType: 'textarea'
    },
    {
      target: 'modalTextStyle',
      label: '文本样式',
      formType: 'textarea'
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ]
}
